/* ==========================================================================
  FacetWP
========================================================================== */

// // facetwo loaded
// document.addEventListener('facetwp-loaded', function() {

// });

// // facetwo refresh
// document.addEventListener('facetwp-refresh', function() {

// });


// detect when sticky element is at the top of the viewport
document.addEventListener('DOMContentLoaded', function() {
  const stickyElement = document.querySelector('.facetwp-facet-service');

  if (stickyElement) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        stickyElement.classList.toggle('is-sticky', entry.intersectionRatio > 0 && entry.intersectionRatio < 1);
      },
      {
        threshold: [1],
        rootMargin: '-1px 0px 0px 0px',
      }
    );

    observer.observe(stickyElement);
  }
});
